export function actionCreator(type, ...params) {
  if (params.length === 0) {
    return {
      type,
    };
  }

  if (params.length === 1) {
    return {
      type,
      payload: params[0],
    };
  }

  return params.reduce(
    (action, param, index) => {
      action.payload[param] = args[index]; // eslint-disable-line
      return action;
    },
    { type, payload: {} },
  );
}

const loadKeyword = 'LOAD';
const startKeyword = 'WAITING';
const failedKeyword = 'FAILED';
const successKeyword = 'COMPLETED';

const FUNC_NAMES = {
  [loadKeyword]: 'load',
  [startKeyword]: 'request',
  [successKeyword]: 'success',
  [failedKeyword]: 'failed',
};

/**
 * @param {string}  namespace - the action namespace
 * @param {string} type - the action type
 * @return {[{LOAD: string, WAITING: string, FAILED: string, COMPLETED: string}, {load: function, success: function, request:function, failed: function]} This is the result
 */
export function flowActionCreator(namespace, type) {
  const types = actionTypeCreatorV2(namespace, type);
  const funcs = Object.keys(types).reduce((acc, key) => {
    acc[FUNC_NAMES[key]] = function _(...res) {
      return actionCreator(types[key], ...res);
    };

    return acc;
  }, {});

  return [types, funcs];
}

export function actionTypeCreatorV2(namespace, type) {
  const actionNameFetch = `${namespace}/${type}_${loadKeyword}`;
  const actionNameStart = `${namespace}/${type}_${startKeyword}`;
  const actionNameFail = `${namespace}/${type}_${failedKeyword}`;
  const actionNameCompleted = `${namespace}/${type}_${successKeyword}`;

  return {
    [`${loadKeyword}`]: actionNameFetch,
    [`${startKeyword}`]: actionNameStart,
    [`${failedKeyword}`]: actionNameFail,
    [`${successKeyword}`]: actionNameCompleted,
  };
}

export function actionTypeCreator(namespace, type) {
  const actionNameFetch = `${namespace}/${type}_${loadKeyword}`;
  const actionNameStart = `${namespace}/${type}_${startKeyword}`;
  const actionNameFail = `${namespace}/${type}_${failedKeyword}`;
  const actionNameCompleted = `${namespace}/${type}_${successKeyword}`;

  return {
    [`${type}_${loadKeyword}`]: actionNameFetch,
    [`${type}_${startKeyword}`]: actionNameStart,
    [`${type}_${failedKeyword}`]: actionNameFail,
    [`${type}_${successKeyword}`]: actionNameCompleted,
  };
}
